import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'myabvv-abvv-membership',
    standalone: true,
    templateUrl: './abvv-membership.component.html',
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AbvvMembershipComponent {
}
